export default __webpack_public_path__ + "static/icon-figure-hugging-ab408f34a03c240a7b8b5e20a89369ff.webp";